exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "notification-dropdown{display:inline-block}notification-dropdown .dropdown-menu.float-right{right:0;left:auto}notification-dropdown .no-border{border:0}notification-dropdown ul.notifications-box li.unread{font-weight:700;background-color:rgba(0,143,226,.1);border-radius:0;border-left:1px solid rgba(0,143,226,.3);border-right:1px solid rgba(0,143,226,.3);border-bottom:0}notification-dropdown ul.notifications-box li.unread+li.unread{border-top:1px solid rgba(0,143,226,.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/notifications/dropdown/dropdown.scss
// module id = 1913
// module chunks = 0